var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { RoleService } from "~/services/manage-service/role.service";
import { Emit } from "vue-property-decorator";
var ModifyRole = /** @class */ (function (_super) {
    __extends(ModifyRole, _super);
    function ModifyRole() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifyModel = {
            roleId: "",
            name: "",
            status: "",
            description: ""
        };
        _this.loading = {
            state: false
        };
        _this.rules = {
            name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
            status: [{ required: true, message: "请选择角色状态", trigger: "change" }]
        };
        return _this;
    }
    ModifyRole.prototype.refreshList = function () { };
    ModifyRole.prototype.close = function () { };
    ModifyRole.prototype.reset = function () {
        var modifyForm = this.$refs["modify-form"];
        modifyForm.resetFields();
    };
    ModifyRole.prototype.refresh = function (obj) {
        this.modifyModel.name = obj.name;
        this.modifyModel.roleId = obj.id;
        this.modifyModel.status = obj.status;
        this.modifyModel.description = obj.description;
    };
    ModifyRole.prototype.commit = function () {
        var _this = this;
        var modifyForm = this.$refs["modify-form"];
        modifyForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.loading.state = true;
            _this.roleService.modifyRole(_this.modifyModel, _this.loading).subscribe(function (data) {
                _this.$message.success("修改成功!");
                _this.refreshList();
                _this.close();
            }, function (_a) {
                var msg = _a.msg;
            });
        });
    };
    __decorate([
        Dependencies(RoleService)
    ], ModifyRole.prototype, "roleService", void 0);
    __decorate([
        Emit("refreshList")
    ], ModifyRole.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ModifyRole.prototype, "close", null);
    ModifyRole = __decorate([
        Component({
            components: {}
        })
    ], ModifyRole);
    return ModifyRole;
}(Vue));
export default ModifyRole;
